
import { getCookie } from "./util/utils";
const token = getCookie("mtoken")

const apolloClientApi = "https://www.bujue.art/graphql?token="+token;
export default apolloClientApi;
